<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객님, 담당자가 선호보험사 설계 확인 후 연락드리겠습니다.</h3></li>
            <li><h4>담당자가 신속하게 연락드릴 수 있는 가장 빠른시간으로 배정해드립니다.<br>상담예약 일시 변경이 필요한 경우 아래에서 상담예약 시간을 변경해주세요.</h4></li>
            
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[0].formData.consultDate.value" :error="processorData.steps[0].formData.consultDate.error" :label="processorData.steps[0].formData.consultDate.label" :placeholder="processorData.steps[0].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[0].formData.consultTime.value" :error="processorData.steps[0].formData.consultTime.error" :label="processorData.steps[0].formData.consultTime.label" :placeholder="processorData.steps[0].formData.consultTime.placeholder"
                :date="processorData.steps[0].formData.consultDate.value"/>
            </li>
            <li><element-textarea v-model="processorData.steps[0].formData.consultRemark.value" :error="processorData.steps[0].formData.consultRemark.error" :label="processorData.steps[0].formData.consultRemark.label" :placeholder="processorData.steps[0].formData.consultRemark.placeholder" /></li>
          </ul>
          <div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[1]">
          <include-consult-complete :data="processorData.steps[1]" />
        </element-processor-step>

      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "(선택)전화 상담 예약 변경",
        steps: [
          {
            title: "상담 예약 변경",
            formData: {
              consultDate: {
                label: "변경 상담예약 일시",
                value: new Date(),
                placehodler: "날짜",
                error: "",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              }
            }
          },
          {
            title: "전화상담 예약 변경이 완료되었습니다.",
            label: "예약하신 상담일시에 상담원이 친절하게 안내해 드리겠습니다."
          }
        ] // steps
      },
      reservationData: {}
    }
  },
  mounted(){
    this.init()
  },
  created() {
    if(this.$route.query.tab) this.processorData.steps[0].formData.insureName.value = this.$route.query.tab
  },
  methods: {
    async init() {
      let _id = this.$store.getters[ "elementModal/GET_ITEM" ]({ elementId: "globalLifeEstimateConsultation" }).reservationId
      let res = await this.$store.dispatch("reservation/getReservation", { _id: _id})
      let { data, error } = res.data
      this.reservationData = data
    },
    submit( finalData ) {
      // this.$store.getters[ "elementModal/GET_ITEM" ]({ elementId: "globalLifeEstimateConsultation" }).reservationId
      //finalData['상담 예약 변경'].step_datas.consultDate.value
      //finalData['상담 예약 변경'].step_datas.consultRemark.value
      // memo는 기존 메모 불러와서 이어 붙여야함.
      this.$store.dispatch( "reservation/updateReservation", {
        _id: this.reservationData._id,
        reservation_memo: this.reservationData.reservation_memo + '\n추가 상담내용 : ' + finalData['상담 예약 변경'].step_datas.consultRemark.value, 
        reservation_date_request: moment(finalData['상담 예약 변경'].step_datas.consultDate.value).format('YYYY-MM-DD') + ' ' + finalData['상담 예약 변경'].step_datas.consultTime.value,
      });
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

      if(this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

        var index = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
        if(value === '미가입' && !this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].requirement){
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.splice(index, 1);
        }
      }else{
        if(value != '미가입'){
          var tmp = { label: this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
          this.processorData.steps[1].formData.insureOptions[this.statusPopup.option].value.push( tmp )
        }
      }
    }
  }
}
</script>
